<template>
    <main class="LayoutMain">
        <keep-alive>
            <router-view :key="viewId"></router-view>
        </keep-alive>
    </main>
</template>

<script>
    export default {
        name: 'LayoutMain',
        computed: {
            viewId() {
                return this.$route.path
            },
        }
    }
</script>

<style src="styles/components/layout/LayoutMain.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/layout/LayoutMain.vue